(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-form"] && !Shopify.designMode) return;
  try {
    const formatPhoneDisplay = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 11);
    const ddd = digits.slice(0, 2);
    const firstPart = digits.slice(2, 7);
    const secondPart = digits.slice(7, 11);

    if (digits.length <= 2) {
      return ddd ? `(${ddd}` : '';
    }

    if (digits.length <= 7) {
      return `(${ddd}) ${firstPart}`;
    }

    return `(${ddd}) ${firstPart}-${secondPart}`;
  };

  document.querySelectorAll('.contact-form__form').forEach((formElement) => {
    const phoneInput = formElement.querySelector('#ContactForm-phone');

    if (!phoneInput) return;

    const initialDigits = phoneInput.value.replace(/\D/g, '').slice(-11);
    if (initialDigits) {
      phoneInput.value = formatPhoneDisplay(initialDigits);
    }

    phoneInput.addEventListener('input', () => {
      phoneInput.value = formatPhoneDisplay(phoneInput.value);
    });

    formElement.addEventListener('submit', () => {
      const phoneDigits = phoneInput.value.replace(/\D/g, '').slice(-11);
      if (phoneDigits) {
        phoneInput.value = `+55${phoneDigits}`;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
